import { render, staticRenderFns } from "./TestPreviewCard.vue?vue&type=template&id=a67667dc&"
import script from "./TestPreviewCard.vue?vue&type=script&lang=js&"
export * from "./TestPreviewCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports